import moment from 'moment';
import { ItemModel } from 'models/Item/Item';
import { RawGroupingDetailData } from './types';
import { ListingModel } from 'models/Listing/Listing';
import { UserModel } from 'models/User/User';
import { TimestampData } from 'models/types';

class GroupingModel {
  id: string;
  name: string;
  item: ItemModel;
  listings: ListingModel[];
  status: string;
  createdBy?: UserModel;
  timestamps: TimestampData;

  constructor(rawGroupingData: RawGroupingDetailData) {
    this.id = rawGroupingData.id;
    this.name = rawGroupingData.name;
    this.status = rawGroupingData.status;
    this.item = new ItemModel(rawGroupingData.item);
    this.listings = rawGroupingData.listings.map(listing => new ListingModel(listing));
    this.createdBy = rawGroupingData.created_by ? new UserModel(rawGroupingData.created_by) : undefined;
    this.timestamps = {
      createdAt: rawGroupingData.timestamps ? moment(rawGroupingData.timestamps.created_at) : null,
      updatedAt: rawGroupingData.timestamps ? moment(rawGroupingData.timestamps.updated_at) : null,
    };
  }

  containsArtist(artistId: string): boolean {
    return this.item.artistId === artistId;
  }

}

export default GroupingModel;
